import { getFingerPrint } from './finger';
import LayerListener from './listener';
import BatchListener from './batchListener';
import { handleSessionId } from './sessionId';
import { initCommonParamStorage } from './commonParam';
import { UPLOAD_TYPE } from './define';
import {
  isCreditPayPointScriptCompatible,
  isV0PointScriptCompatible,
  isV1PointScriptCompatible,
  isV2PointScriptCompatible,
  isV35PointScriptCompatible,
  isV3PointScriptCompatible,
} from './checkPoint';

// 本页已交出且脚本版本足够时，由 hw.point.js 挂监听，避免双监听
if (!isV35PointScriptCompatible()) {
  new LayerListener('webstorev35DataLayer', UPLOAD_TYPE.webstorev35);
}

if (!isV3PointScriptCompatible() || window.isOfficialTopupSupplement) {
  new LayerListener('webstorev3DataLayer', UPLOAD_TYPE.webstorev3);
}

if (!isV2PointScriptCompatible()) {
  new LayerListener('webstorev2DataLayer', UPLOAD_TYPE.webstorev2);
}

if (!isV1PointScriptCompatible()) {
  new LayerListener('webstorev1DataLayer', UPLOAD_TYPE.webstorev1);
}

if (!isCreditPayPointScriptCompatible()) {
  new LayerListener('creditPayDataLayer', UPLOAD_TYPE.creditpay);
}

if (!isV0PointScriptCompatible()) {
  new LayerListener('sdkstoreDataLayer', UPLOAD_TYPE.sdkstore);
}

const officialPassportDataLayer = new LayerListener(
  'officialPassportDataLayer',
  UPLOAD_TYPE.officialPassport
);

const passportDataLayer = new LayerListener(
  'passportDataLayer',
  UPLOAD_TYPE.passport
);

const csorderDataLayer = new LayerListener(
  'csorderDataLayer',
  UPLOAD_TYPE.csorder
);

const dmaListener = new LayerListener('dmaDataLayer', UPLOAD_TYPE.dma);
const userAgreementListener = new LayerListener(
  'userAgreementDataLayer',
  UPLOAD_TYPE.userAgreement
);


const webstorev0Listener = new LayerListener(
  'webstorev0DataLayer',
  UPLOAD_TYPE.webstorev0
);

const initCommonParams = () => {
  getFingerPrint();

  try {
    initCommonParamStorage();
  } catch (e) {
    console.log(e);
  }
};

export const initBiPoint = ({
  dataLayerName,
  needInitCommonParams = true,
  sendSessionEnd = false
}) => {
  needInitCommonParams && initCommonParams();
  handleSessionId({ dataLayerName, sendSessionEnd });
};

/**
 * 初始化批量上报方案
 * @param {Object} options - 配置选项
 * @param {String} options.dataLayerName - dataLayer名称（如'webstorev35DataLayer'）
 * @param {String} options.uploadType - 上报类型（如UPLOAD_TYPE.webstorev35）
 * @param {Boolean} options.needInitCommonParams - 是否初始化公共参数
 * @param {Boolean} options.sendSessionEnd - 是否发送会话结束
 * @param {Object} options.batchConfig - 批量配置（可选）
 * @returns {BatchListener} 批量监听器实例
 */
export const initBatchBiPoint = ({
  dataLayerName,
  uploadType,
  needInitCommonParams = true,
  sendSessionEnd = false,
  batchConfig = {}
}) => {
  needInitCommonParams && initCommonParams();
  handleSessionId({ dataLayerName, sendSessionEnd });

  // 创建批量监听器
  const batchListener = new BatchListener(
    dataLayerName,
    uploadType,
    batchConfig
  );

  return batchListener;
};

// 导出BatchListener供外部使用
export { BatchListener };
